import React from "react";
import "./WarningBar.css";

function WarningBar() {
    return (
        <div className="warning-bar">
            ⚠️ Never give out your password or credit card number in an instant message conversation.
        </div>
    );
}

export default WarningBar;